import React from "react";
import styled from "styled-components";
import XandrCredentialsForm from "../components/XandrCredentialsForm";
import logo from "./logo.png";
import { useNavigate } from "react-router-dom";

const SetupPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
`;

const Logo = styled.img`
  height: 80px;
  margin-bottom: 30px;
`;

const SetupCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 500px;
`;

const XandrSetupPage = ({ onSaved }) => {
  const navigate = useNavigate();

  const handleCredentialsSaved = () => {
    if (onSaved) {
      onSaved();
    }
    // Redirection explicite vers la page d'accueil
    navigate("/");
  };

  return (
    <SetupPageContainer>
      <Logo src={logo} alt="Sirdata Logo" />
      <SetupCard>
        <XandrCredentialsForm onSaved={handleCredentialsSaved} />
      </SetupCard>
    </SetupPageContainer>
  );
};

export default XandrSetupPage;
